import Vue from "vue";
import App from "./App.vue";
import "./fonts/font.css";
import "@/style/style.scss";
import router from "./router/index";
// import VueVideoPlayer from "vue-video-player";
// import "video.js/dist/video-js.css";
// Vue.use(VueVideoPlayer);
// import "@/utils/flexRem";
import ElementUI from "element-ui"; //全局引入element
import "element-ui/lib/theme-chalk/index.css"; //全局引入element的样式
Vue.use(ElementUI);
Vue.config.productionTip = false;

new Vue({
  router,

  render: (h) => h(App),
}).$mount("#app");
